import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class VaultAlternateDistributionRecipientType extends Enum {
  static EVERYTHING_TO_MY_EXISTING_AND_FUTURE_CHILDREN = {
    key: 'everything_to_my_existing_and_future_children',
    get value() {
      return Lang.t('vaultdistributionsetting.everything-to-future');
    }
  };

  static EVERYTHING_TO_MY_SIBLINGS = {
    key: 'everything_to_my_siblings',
    get value() {
      return Lang.t('vaultdistributionsetting.everything-to-siblings');
    }
  };

  static EQUAL_SPLIT_TO_THEIR_SIBLINGS = {
    key: 'equal_split_to_their_siblings',
    get value() {
      return Lang.t('vaultdistributionsetting.their-share-to');
    }
  };

  static EQUAL_SPLIT_TO_THEIR_EXISTING_AND_FUTURE_CHILDREN = {
    key: 'equal_split_to_their_existing_and_future_children',
    get value() {
      return Lang.t('vaultdistributionsetting.their-is-future');
    }
  };

  static EQUAL_SPLIT_TO_OTHER_BENEFICIARIES = {
    key: 'equal_split_to_other_beneficiaries',
    get value() {
      return Lang.t('vaultdistributionsetting.their-is-among');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('guidancestep.other-distribution');
    }
  };
}
